<article [ngClass]="styleClasses()" #articleWrapper [id]="content().segment | decodeURI: true">
  @if (!hideMediaContentImage() && mappedImage()) {
    <div class="image-container">
      <fin-content-image
        class="block image-height mr-medium-b radius-medium"
        [scale]="scaleImage()"
        [imageData$]="mappedImage() | finToObservable"
      />
    </div>
  }
  @if (title()) {
    @if (icons()?.length) {
      <div class="flex icon-with-heading mr-xsmall-b">
        @for (icon of icons(); track icon.name) {
          <fcom-icon
            [category]="icon.category ?? IconLibrary.SVG_LIBRARY"
            [name]="icon.name"
            class="icon-large ms-small-r"
          />
        }
        @if (resolvedHeaderLevel()) {
          <fcom-heading-tag [extraClasses]="headerExtraClasses()" [level]="resolvedHeaderLevel()">
            {{ title() }}
          </fcom-heading-tag>
        } @else {
          <span class="bold-type" [class.flex--self-center]="icons()?.length">
            {{ title() }}
          </span>
        }
      </div>
    } @else {
      <fcom-heading-tag [extraClasses]="headerExtraClasses()" [level]="resolvedHeaderLevel() || DEFAULT_HEADER_LEVEL">
        {{ title() }}
      </fcom-heading-tag>
    }
  }
  <div #contentWrapper [innerHTML]="mappedContent() | finSafe: 'html'"></div>
</article>
